import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { Overlay, BlockScrollStrategy, ScrollStrategyOptions, CdkConnectedOverlay, ScrollStrategy } from '@angular/cdk/overlay';

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}

@Component({
  selector: 'app-searchable-dropdown',
  templateUrl: './searchable-dropdown.component.html',
  styleUrls: ['./searchable-dropdown.component.scss'],
  providers: [
    { provide: MAT_SELECT_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] }
  ]
})
export class SearchableDropdownComponent implements OnInit {
  @Input() values: any[] = [];
  @Input()  selected :any
  @Input() disabled :boolean = false
  @Input() displayMember:string ="name";
  @Input() selectCaption:string = "";
  @Input() maxTags = 4;
  @Input() type = 'array';
  variables:any = [];
  filteredList:any = [];
  @Output() newSelectionEvent = new EventEmitter<string>();
  @Input() isMultiple:boolean=false;
  scrollStrategy:ScrollStrategy
  selectedItem: any;
  noTags: boolean=false;
  noAssests: boolean=false;
   constructor() { }

  ngOnInit(): void {
    this.variables = []
      this.variables = this.values;
    this.filteredList = this.variables;
    // this.selectedItem = this.selected[0].tag
  }
  ngOnChanges(changes: SimpleChanges) {
    if(changes) {
      if(changes.values && changes.values.currentValue) {
        this.values = changes.values.currentValue;
        this.variables = this.values;
        this.filteredList = this.variables;
      }
      if(changes.selected && changes.selected.currentValue) {
        this.selected = changes.selected.currentValue;
      }
    }
  }
  selectionChangedAsset(event:any){
    if(event.value.length===0){
      this.noAssests = false;
    }
    else{
      this.noAssests=true;
    }
  }
  selectionChanged(event:any){
    if(event.value.length===0){
      this.noTags=true;
    }
    else{
      this.noTags=false;
    }
    if(this.isMultiple) {
      
      // if(event.value.length == 1){
      //   this.selectedItem = event.value[0].tag
      //   this.newSelectionEvent.emit(event.value);
      // }else{
      //   this.selectedItem = ""
      //   if(event.value.length<=this.maxTags) {
      //     this.newSelectionEvent.emit(event.value);
      //   } else {
      //     event.value = event.value.splice(0, event.value.length-1);
      //     this.selected = event.value;
      //   }
      // }
      this.selectedItem = ""
      if(event.value.length<=this.maxTags) {
        this.newSelectionEvent.emit(event.value);
      } else {
        event.value = event.value.splice(0, event.value.length-1);
        this.selected = event.value;
      }
    } else {
      this.newSelectionEvent.emit(event.value);
    }
    
  }

}
